import RDAxios from '../../http/requests/request-durations/index.js';

export default {

    getRequestDurations ({ commit }, payload) {
        return RDAxios.getRequestDurations(payload.httpOptions);
    },

    openEditModal ({ commit }, data) {
        commit('TOGGLE_EDIT_MODAL', {
            open: true,
            data: data,
        });
        commit('SET_EDIT_MODAL_DATA', data);
    },
    toggleListRefresh ({ commit }, status) {
        commit('TOGGLE_LIST_REFRESH', status);
    },
    updateRequestDuration ({
        commit,
        state,
    }, payload) {

        let data = JSON.parse(JSON.stringify(payload.requestDuration));
        return new Promise((resolve, reject) => {
            RDAxios.updateRequestDuration(data)
                .then(response => {
                    commit('SET_EDIT_MODAL_ERRORS', {});
                    commit('SET_EDIT_MODAL_DATA', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_EDIT_MODAL_ERRORS', error.response.data.data);
                    }

                    reject(error);
                });
        });
    },

    setData ({ commit }, data) {
        commit('SET_EDIT_MODAL_DATA', data);
    },
    closeEditModal ({ commit }) {
        commit('TOGGLE_EDIT_MODAL', {
            open: false,
            id: null,
            ticket: null,
        });
    },
    getRequestDuration ({ commit }, id) {
        return new Promise((resolve, reject) => {
            RDAxios.getRequestDuration(id)
                .then(response => {
                    if (!response.data.success) {
                        reject({ message: response.data.message });
                    }

                    commit('SET_EDIT_MODAL_DATA', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
};
